import { render, staticRenderFns } from "./orangeOptModal.vue?vue&type=template&id=a477c8b2&scoped=true&"
import script from "./orangeOptModal.vue?vue&type=script&lang=js&"
export * from "./orangeOptModal.vue?vue&type=script&lang=js&"
import style0 from "./orangeOptModal.vue?vue&type=style&index=0&id=a477c8b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a477c8b2",
  null
  
)

export default component.exports